<template>

	<div :class="{'mainLogo-white': isWhite}" class="mainLogo">
		<router-link :to="{name: 'home'}">
			<svg viewBox="0 0 182.562 100.6" xmlns="http://www.w3.org/2000/svg">
				<path id="mainLogo_path" d="M0,0A23.6,23.6,0,0,0,9.485-8.91a25.2,25.2,0,0,0,3.449-13.222q0-12.213-9.628-19.186t-27.45-6.97H-71.282v42.51h-9.512a40.894,40.894,0,0,0,.555-6.725q0-11.065-5.174-19.114a33.121,33.121,0,0,0-14.874-12.359q-9.7-4.312-22.778-4.312h-41.39v100.6h18.683V23.282h22.707q13.074,0,22.778-4.312A33.542,33.542,0,0,0-86.9,8.664h15.62V52.312H-21.27q19.257,0,29.318-7.114T18.107,25.006q0-9.484-4.885-15.88A26.571,26.571,0,0,0,0,0M-99.065-12.5q0,9.63-6.324,14.8t-18.539,5.174h-21.844V-32.479h21.844q12.214,0,18.539,5.173t6.324,14.8m93.172-7.186A11.6,11.6,0,0,1-11.138-9.413Q-16.387-5.89-26.156-5.892H-52.6V-33.629h26.444q9.771,0,15.018,3.521t5.245,10.419M-.719,23.138q0,14.517-21.7,14.515H-52.6V8.623h30.181q21.7,0,21.7,14.515"
				      data-name="Tracé 18"
				      transform="translate(164.455 48.288)"/>
			</svg>
		</router-link>
	</div>

</template>

<script>
export default {
	name: "MainLogo",
	props: ["isWhite"]
};
</script>

<style lang="scss" scoped>
.mainLogo {
	width: 8rem;

	a {
		display: flex;

		svg {
			width: 100%;
			height: 100%;
		}
	}

	path {
		@include transition();
	}

	&-white {
		path {
			fill: #ffffff;
		}
	}
}

.intro_logo {
	.mainLogo {
		svg {
			fill: #444e5e;
		}
	}
}
</style>